<template>
    <div class="menuheaderbigbox">
        <div  :class="[layoutChange  ?  'menu-header' : 'menu-header-active']" >
            <div class="box-view-content">
                <div class="box-shadow">
                    <div class="menu-isShow" style="overflow: hidden;white-space:nowrap;">
                        <!-- <i class="iconfont icon-jianshaosuojin font_size" @click="changeCOllapse"></i>  -->
                        <el-breadcrumb separator-class="el-icon-arrow-right" class="hidden-sm-and-down">
                            <transition-group name="breadcrumb" mode="out-in">
                                <template v-for="item in breadList" >
                                    <el-breadcrumb-item v-if="item.path!='/'" :key="item.title">
                                        <i class="iconfont" :class="item.icon"></i>
                                        {{item.title}}
                                    </el-breadcrumb-item>
                                </template>
                            </transition-group>
                        </el-breadcrumb>
                        <CommonTag ref="CommonTage" v-if="false"/>
                    </div>
                    <div class="menu-news">
                        <div class="personal_news">
                            <!-- 显示屏蔽设备报警黑名单弹出框 以及 展示屏蔽设备内容 的icon图标按钮 -->
                            <!-- <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'"  :content='$t("basic.all.header_closeBlackAlarmDevice")' placement="top" >
                                <div @click="getBlackDeviceDataList" style="display:flex;justify-content:center" id="B">
                                    <i class="iconfont icon-lixianjingbao" style="margin:0 6px;cursor:pointer; font-size: 24px;" ></i>
                                </div>
                            </el-tooltip> -->

                            <div class="connect_state textPoint">
                                <el-tooltip v-if="connectState" class="item" effect="dark" :content='$t("mqttConnect.success")'  placement="top">
                                    <i  style="color: #67c23a;">{{ $t("mqttConnect.success") }}</i>
                                </el-tooltip>
                                <el-tooltip v-else class="item" effect="dark" :content='$t("mqttConnect.fail")'  placement="top">
                                    <i  style="color: #f56c6c;">{{ $t("mqttConnect.fail") }}</i>
                                </el-tooltip>
                            </div>
                            <!-- <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'"  :content='$t("basic.all.header_alarmBell")' placement="top" >
                                <div @click="chagneAudio" style="display:flex;justify-content:center" id="B"><i class="iconfont icon-gaojing" style="margin:0 6px;cursor:pointer"></i></div>
                            </el-tooltip> -->
                            <!--  -->
                            <el-popover
                                placement="bottom"
                                width="200"
                                v-model="showToggleColor"
                                >
                                <div class="set-menu-bgcolor-box">
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.bgMenuColor")}}: </span>
                                        <el-color-picker v-model="localSet.menuBg" size="mini" @active-change="val => toggleMenuStyle(val, 'menuBg')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.textMenuColor")}}: </span>
                                        <el-color-picker v-model="localSet.menuTC" size="mini" @active-change="val => toggleMenuStyle(val, 'menuTC')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.acMenuTextCol")}}: </span>
                                        <el-color-picker v-model="localSet.menuATC" size="mini" @active-change="val => toggleMenuStyle(val, 'menuATC')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.hovBgColor")}}: </span>
                                        <el-color-picker v-model="localSet.HMC" size="mini" @active-change="val => toggleMenuStyle(val, 'HMC')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.hovTextCOlor")}}: </span>
                                        <el-color-picker v-model="localSet.HTC" size="mini" @active-change="val => toggleMenuStyle(val, 'HTC')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.acMenuBgColor")}}: </span>
                                        <el-color-picker v-model="localSet.MABC" size="mini" @active-change="val => toggleMenuStyle(val, 'MABC')"></el-color-picker>
                                    </div>
                                    <div class="bgcolor-item default-style"  @click="initializeSetting(1)">
                                        <span style="margin-right: 10px;">默认样式一</span>
                                    </div>
                                    <div class="bgcolor-item default-style"  @click="initializeSetting(2)">
                                        <span style="margin-right: 10px;">默认样式二</span>
                                    </div>
                                    <div class="bgcolor-item default-style"  @click="initializeSetting(3)">
                                        <span style="margin-right: 10px;">默认样式三</span>
                                    </div>
                                    <div class="bgcolor-item default-style"  @click="initializeSetting(0)">
                                        <span style="margin-right: 10px;">{{$t("basic.ApplicationCenterPage.initSet")}}</span>
                                    </div>
                                </div>
                                <el-tooltip slot="reference" class="item" effect="dark" :content="$t('basic.ApplicationCenterPage.personSet')" placement="bottom"  @click="showToggleColor = !showToggleColor">
                                    <i  class="el-icon-magic-stick"  style="margin:0 10px;cursor:pointer" ></i>
                                </el-tooltip>
                            </el-popover>

                            <el-dropdown placement="bottom" @command="changeLangeuage" >
                                <div style="display:flex;justify-content:center"><i class="iconfont icon-yuyan-02" style="margin:0 10px;cursor:pointer"></i></div>

                                <el-dropdown-menu slot="dropdown" style="width: 100px;margin: 10px 0;" >
                                    <el-dropdown-item command="zh" style="padding-left: 10px;">简体中文</el-dropdown-item>
                                    <el-dropdown-item command="en" style="padding-left: 10px;">English</el-dropdown-item>
                                    <el-dropdown-item command="ko" style="padding-left: 10px;">한국어</el-dropdown-item>
                                    <el-dropdown-item command="ru" style="padding-left: 10px;">Русский</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'" :content='$t("basic.menubar.workbench")' placement="top" >
                                <div @click="changeRouter(1)" style="display:flex;justify-content:center" id="B"><i class="iconfont icon-gongzuotai" style="margin:0 6px;cursor:pointer"></i></div>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'" content='样式设置' placement="top" >
                                <div @click="changeRouter(4)" style="display:flex;justify-content:center"><i class="iconfont icon-yifu" style="margin:0 6px;cursor:pointer"></i></div>
                            </el-tooltip> -->
                            <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'" :content='$t("basic.menubar.moreHelp")' placement="top">
                                <div @click="changeRouter(3)"><i class="iconfont icon-wenhao-xianxingyuankuang" style="margin:0 6px;cursor:pointer"></i></div>
                            </el-tooltip>
                            <el-tooltip class="item" :effect="this.$CONFIG.THEME=='light'?'dark':'light'" :content='$t("basic.menubar.backstageHomePaee")' placement="top">
                                <div @click="changeRouter(2)"><i class="iconfont icon-shouye1" style="margin:0 6px;cursor:pointer;margin-right:15px"></i></div>
                            </el-tooltip>
                            
                            <div class="image fl_align_cen">
                               <i class="iconfont icon-touxiang" style="font-size: 25px;"></i>
                               <!-- <el-image :src="src" style="width:100%;height: 100%;border-radius: 50%;"></el-image> -->

                            </div>
                            <div class="name">
                                {{ userName }}
                            </div>
                            <el-popconfirm
                                :confirm-button-text='this.$t("basic.public.confirmNospace")'
                                :cancel-button-text='$t("basic.menubar.cancel")'
                                icon="el-icon-info"
                                icon-color="red"
                                :title='$t("basic.menubar.logOut")'
                                @confirm="logOout"
                            >
                                <el-button type="danger" icon="el-icon-switch-button" circle slot="reference"></el-button>
                            </el-popconfirm>
                        </div>
                        <div class="personal_news_hover">

                        </div>
                    </div>
                </div>    
            </div>
        </div>

            <!-- 显示已经屏蔽的用户 -->
            <!-- <el-dialog  
            :visible.sync="dialogTableVisible"
            :modal="true"
            :append-to-body="true"
            center
            >   
                <div class="closeDeviceAlarm">
                    <div style="margin-right:10px;">
                        <el-input  placeholder='请输入设备编号' v-model="deviceNumber" :clearable="true"></el-input>
                    </div>
                    <div class="clear">
                        <el-tooltip :content='$t("basic.public.clearSear")' placement="top">
                            <el-button class="clear" type="primary" style="margin-right: 15px;" size="medium" @click="clearSearchValue">
                                <i class="iconfont icon-shanchujinzhi"></i>
                            </el-button>
                        </el-tooltip>
                    </div>
                    <div class="search">
                        <el-tooltip :content='$t("basic.search.search")' placement="top">
                        <el-button  class="search" type="primary" style="margin-right: 15px; margin-left: 10px;" size="medium" @click="SerachBtn">
                                <i class="iconfont icon-sousuo" ></i>
                            </el-button>
                        </el-tooltip>
                    </div>
                </div>
                <el-table :data="deviceBlackData" style="width: 100%" max-height="420" :header-cell-style="{'text-align': 'center'}">
                    
                    <el-table-column
                    :property="item.prop" 
                    :label="$t(item.label)" 
                    width="150"
                    v-for="(item, index) in deviceBlackTableHeader"
                    :key="index"
                    :show-overflow-tooltip = "true"
                    align="center"
                    ></el-table-column>
                    
                    <el-table-column
                        label="操作"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-popconfirm
                            :title='$t("basic.public.sureUnblock")'
                            @confirm="deleteDeviceAlarm(scope.row)"
                            >
                            <el-button slot="reference" icon="el-icon-delete" type="danger" size="medium" style=" width: 100px; height: 35px;">{{$t("basic.public.Unblock")}}</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
                </el-table>
            </el-dialog> -->

            <!-- 选择报警铃声 -->
        <el-dialog
        :title="$t('basic.all.header_alarmBell')"
        :visible.sync="dialogVisible"
        width="400px"
        :destroy-on-close="true"
        :append-to-body="true"
        >
        <div style="width: 100%;height: 80px;">
            <el-radio-group v-model="newAduio" @input="changeAduio">
                <div style="padding-bottom: 20px;">
                <el-radio  label="addr"><span style="font-size: 20px;" >{{ $t('basic.all.header_alarmRadio1') }}</span></el-radio>
            </div>
            <div >
                <el-radio  label="mp3"><span style="font-size: 20px;" >{{ $t('basic.all.header_alarmRadio2') }}</span></el-radio>
            </div>
        </el-radio-group>
        
        </div>
        
        </el-dialog>
    </div>
</template>
<script>
import CommonTag from './tabMenu.vue'
import { mapMutations } from 'vuex'

export default{
    name:'menuHeader',
    components:{
        CommonTag
    },
    data(){
        return{
            // routes:this.$router.options.routes,
            routes:[],
            isShowHeader:false,
            test:[],
            breadList: [
                {
                    title:this.$t("basic.menubar.backstageManage"),
                    icon:'iconfont icon-houtaiguanli',
                    name:'home',
                }
            ],
            driver:null,
            testShow:false,
            src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
            userName:'',
            // userName:this.$store.state.
            ListMenu:'',
            dialogVisible:false,
            newAduio:null,
            dialogTableVisible: false,
            deviceBlackTableHeader: [
                {
                    label: "basic.public.deviceCoding",
                    prop: "device_number",
                },
                {
                    label: "basic.all.user_name",
                    prop: "contact_name",
                },
                {
                    label: "basic.public.MobilePhone",
                    prop: "contactr_phone",
                },
                {
                    label: "basic.public.siteName",
                    prop: "site_name",
                },
                {
                    label: "basic.public.create_date",
                    prop: "create_datetime",
                },
            ],
            // 屏蔽报警设备黑名单
            deviceBlackData: [],
            deviceNumber: null,
            // connectState: true, // mqtt连接状态
            localSet: {},
            showToggleColor: false,
        }
    },
    watch: {
        $route() {
            this.getBreadcrumb();
        },
       
    },
    props:{
        layoutChange:{
           
        }
    },
    mounted(){
        setTimeout(()=>{
            this.newAduio = localStorage.getItem('aduio')
        },500)
        this.userName = JSON.parse(localStorage.getItem("AllTitle")).user_name
        this.getBreadcrumb();
        this.ListMenu = JSON.parse(localStorage.getItem("menu"));
        let localSet = JSON.parse(localStorage.getItem("localSet"));
        if (!localSet) {
            // this.$router.name("")
            // this.$router.push({name: "ApplicationCenter"})
            localSet = {}
        }
        // 菜单背景颜色
        localSet.menuBg = localSet.menuBg ? localSet.menuBg : "#292f31";
        // 菜单文字颜色
        localSet.menuTC = localSet.menuTC ? localSet.menuTC : "#a0a5bd";
        // 激活菜单的文字颜色
        localSet.menuATC = localSet.menuATC ? localSet.menuATC : "#28a9ff";
        // 鼠标移入时背景颜色
        localSet.HMC = localSet.HMC ? localSet.HMC : "#115ae0";
        // 鼠标移入时文字颜色
        localSet.HTC = localSet.HTC ? localSet.HTC : "#fff";
        // 菜单被激活时背景颜色
        localSet.MABC = localSet.MABC ? localSet.MABC : "rgba(15, 87, 222, .4)";

        this.localSet = localSet;
        localStorage.setItem("localSet", JSON.stringify(localSet))
        // this.$store.state.worker.addEventListener('message', this.workerMessage)
        window.addEventListener('resize', this.resize)
    },
    beforeDestroy() {
        // this.$store.state.worker.removeEventListener('message', this.workerMessage)
        window.removeEventListener('resize', this.resize)
    },
    computed: {
        connectState() {
            return this.$store.state.connectState;
        },
    },
    methods:{
        ...mapMutations(['delUserInfo','delToken','delMenu']),
        // 清空黑名单弹出框条件查询内容
        clearSearchValue(){
            // 清空输入框
            this.deviceNumber = null;
            
            // 重新查询设备
            // this.getBlackDeviceDataList();

        },
        showToggle() { 
            this.showToggleColor = true;
        },
        resize() {
        },
        // workerMessage(e) {
        //     if( e.data.log ){
        //         if( e.data.log != "success" ){
        //             this.connectState = false;
        //         } else {
        //             this.connectState = true;
        //         }
        //     }
        // },
        // 初始化设置
        initializeSetting(type) {
            let data = {};
            if (type === 0) {
                data.menuBg = "#292f31"
                data.menuTC = "#a0a5bd";
                data.menuATC = "#28a9ff";
                data.HMC = "#115ae0";
                data.HTC = "#fff";
                data.MABC = "rgba(15, 87, 222, .4)";
            } else if (type === 1) {
                data.menuBg = "#566d97";
                data.menuTC = "#eee"; 
                data.menuATC = "#fff";
                data.HMC = "#465678";
                data.HTC = "#ddd";
                data.MABC = "#36445e";
            } else if (type === 2) {
                data.menuBg = "#333e50";
                data.menuTC = "#b8bcc2";
                data.menuATC = "#fff";
                data.HMC = "#1e2531";
                data.HTC = "#fff";
                data.MABC = "#56a693";
            } else if (type === 3) { 
                data.menuBg = "#42536b";
                data.menuTC = "#ddd";
                data.menuATC = "#333";
                data.HMC = "#a5bcc4";
                data.HTC = "#333";
                data.MABC = "#a6bdc3"
            }
            this.localSet = data;
            localStorage.setItem("localSet", JSON.stringify(this.localSet));
            this.$store.commit("setLocalSet", this.localSet)
            this.showToggleColor = false;
        },
        toggleMenuStyle(val, name) {
            this.localSet[name] = val;
            this.$store.commit("setLocalSet", this.localSet);
            localStorage.setItem("localSet", JSON.stringify(this.localSet));
        },
        // 取消设备警告黑名单
        /*
        async deleteDeviceAlarm( item ){
            let data = null;
            let that = this;
            data = await that.$API.device.deletePreventDeviceAlarm.post({deviceId: item.id})
            await this.$message({
                message: "取消屏蔽设备成功",
                type: "success"
            })
            this.deviceBlackData = this.deviceBlackData.filter( val => item.id != val.id);
            return;
        },
        */
       
        // 搜索按钮 
        SerachBtn(){
            if( this.deviceNumber == null || this.deviceNumber.length == 0 || this.deviceNumber == "" ){
                this.$message({
                    message: this.$t("cameraImg.enterCode"),
                    type: "warning"
                })
                return;
            }
            this.deviceBlackData = this.deviceBlackData.filter( item => item.device_number == this.deviceNumber );
        },

        // 获取屏蔽设备信息的fn
        // 获取已经被屏蔽的报警列表
        /*
        async getBlackDeviceDataList(){
            let data = null;
            let that = this;
            data = await that.$API.device.getBlackAlarmDeviceList.get();
            this.dialogTableVisible = true
            if(data.code == 200){
                if(!data.data.count) return;  // 请求到的数据中没有被屏蔽的设备, 不执行以下的操作
                this.deviceBlackData = [...data.data.data];
                this.deviceBlackData.forEach(item => {
                    for (const key in item) {
                        if ( item[key] == "" || item[key] == null) {
                            item[key] = "--"; 
                        }
                    }
                })
                return;
            }
            this.$message({
                message: "没有被屏蔽报警的设备",
                type: "error"
            })
        },
       */

        changeCOllapse(){
            this.$store.dispatch('changeCollapse')
        },
        gotoHeaderChile(key,keyPath){
            if(keyPath.length == 2){
                this.$router.push(`/`+ keyPath[0] +`/` +keyPath[1])
            }else if(keyPath.length == 3){
                if(keyPath[0] == 550){
                    this.$router.push(`/` +keyPath[1]+`/`+keyPath[2])
                }else{
                    this.$router.push(`/`+ keyPath[0] +`/` +keyPath[1]+`/`+keyPath[2])
                }
            } else{
                this.$router.push(`/`+ keyPath[0] )
            }
        },
        //退出登录
        logOout(){
            // if(this.$CONFIG.MQTT_CLINET !=null &&this.$CONFIG.MQTT_CLINET.connected){
            //     let topic = 'device/alarm/' + localStorage.getItem("loginName")
            //      this.$CONFIG.MQTT_CLINET.unsubscribe(topic,err=>{
            //     })
            // }
            if( this.$store.state.worker ){
                this.$store.state.worker.postMessage({
                    cancelSubScript: true,
                })
            }
            this.delUserInfo()
            this.delToken()
            this.delMenu()
            this.delCookie();//调用 
            this.$router.push({name:'login'})
        },
        delCookie() {
            document.cookie = "sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        },
       async getBreadcrumb(){
            // let matched = this.$route.matched;
            this.ListMenu = JSON.parse(localStorage.getItem("menu"))
            this.breadList = [
                {
                    title:this.$t("basic.menubar.backstageManage"),
                    icon:'iconfont icon-houtaiguanli',
                    name:'home',
                }
            ],
            await  this.getMeta(this.ListMenu, this.$route.matched[1].path) 

            if(this.$route.matched.length > 2){
                await this.getMeta(this.ListMenu, this.$route.matched[2].path) 
            }
            
        },
        changeRouter(num){
            if(num == 1){
                this.$router.push({name:'ApplicationCenter'})
            }else if(num == 2){
                this.$router.push({name:'adminHome'})
            }else if(num ==3){
                const w = window.open("about:blank");
                w.location.href = 'https://www.yuque.com/yiguangjun/iu554o?#'
                
            }else if(num == 4){
                this.$store.commit('openDrwer')
            }
        },
          // 拼接服务器URL
        getURL(url){
            return this.$TOOL.getMediaUrl(url)
        },

        getMeta(list,title){
            list.forEach(item=>{
               if(item.path == title){
                    this.breadList.push(item.Meta)
                    return
               }else{
                if(item.children){
                    // 有子
                    this.getMeta(item.children,title)
                }
               }
            })
        },

        transfer(){
            // this.$refs.CommonTage.tiao(val)
        },
         // 切换语言
        changeLangeuage(val){
            let language = localStorage.getItem("theLanguage");
            if (language === val) return;
            localStorage.setItem("theLanguage",val)
            this.$store.commit('changeLanguage',val)
            this.$router.go(0)
        },

        chagneAudio(){
            this.dialogVisible = true
        },
        changeAduio(val){
            localStorage.setItem('aduio',val)
        },
        
        

    },
}

</script>
<style lang="scss" scoped>

// @import "@/assets/scss/elemtntChange/menuLaout.scss";
@import "@/assets/scss/menu/menu_header.scss";
@import "@/assets/scss/flex/flex-all.scss";

.closeDeviceAlarm{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    .clear{
        width: 40px;
        height: 40px;
    }
    .search{
        width: 40px;
        height: 40px;
    }
}
.connect_state{
    font-weight: 600;
    // width: 500px;
    text-align: right;
    color: #67c23a;
    i{
        font-size: 18px !important;
    }
}
.set-menu-bgcolor-box{
    text-align: center;
    .bgcolor-item{
        padding: 6px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        
    }
    .default-style{
        &:hover{
            background-color: rgba(105, 81, 81, 0.5);
            cursor: pointer;
            border-radius: 10px;
            color: #fff
        }
    }
}


</style>